import React, { useState, useEffect } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import toast, { Toaster } from "react-hot-toast";
import "./Stripe.css";
import secureLocalStorage from "react-secure-storage";

const StripeFree = () => {
  const [userId, setUserId] = useState(null);
  const navigate = useNavigate();

  useEffect(() => {
    const storedUserId = secureLocalStorage.getItem("Id");
    if (storedUserId) {
      setUserId(storedUserId);
    }
  }, []);

  const ProceedCheckout = async (e) => {
    e.preventDefault();
    // Your existing code
    try {
      console.log(userId);
      if (userId) {
        const response = await axios.post(
          "http://127.0.0.1:8000/get-free-subscription",
          { user: userId }
        );

        if (response.status === 200) {
          const subInfo = {
            plan: response.data.Title,
            account_type: response.data.AccountType,
            date: response.data.date,
          };
          secureLocalStorage.setItem("Subscription", true);
          secureLocalStorage.setItem("SubInfo", JSON.stringify(subInfo));
          secureLocalStorage.setItem("Status", "none");
          navigate("/stripe/success");
        } else {
          toast(
            "An error occurred during subscription. Please try again later.",
            {
              duration: 3000,
              style: {
                fontSize: "20px",
                borderRadius: "10px",
                background: "var(--color-white-50)",
                color: "#fff",
              },
            }
          );
          console.error("Error:", response.data);
        }
      }
    } catch (error) {
      toast("User Information is missing. Please try again later.", {
        duration: 3000,
        style: {
          fontSize: "20px",
          borderRadius: "10px",
          background: "var(--color-white-50)",
          color: "#fff",
        },
      });
      console.error("Error:", error);
    }
  };

  return (
    <section className="section">
      <div className="divwoocommerce">
        <div className="formmargin">
          <div className="formG">
            <div className="frame-parent">
              <div className="cell-parent">
                <div className="cell" />
                <div className="cell1">
                  <b className="product">Product</b>
                  <button className="cell2">
                    <b className="stripe-price">Price</b>
                  </button>
                </div>
              </div>
              <button className="cell3">
                <b className="subtotal">Subtotal</b>
              </button>
            </div>
            <div className="stripe-body">
              <div className="row">
                <div className="data">
                  <div className="stripe-data">$0</div>
                </div>
                <div className="data1">
                  <div className="stripe-data">$0</div>
                </div>
                <div className="data2">
                  <img
                    className="logo-forex-miner-1-icon"
                    alt=""
                    src="/forexLogo_blackBackground.png"
                  />
                  <div className="formLink">
                    <div className="forex-miner-paid">
                      Forex Miner Free Subscription
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className="divcart-collateralsmargin">
          <div className="divcart-collaterals">
            <div className="cart-totals-wrapper">
              <h3 className="cart-totals">Cart totals</h3>
            </div>
            <div className="proceed-to-checkout-link">
              <div className="cart-footer">
                <div className="cell-footer">
                  <div className="total">Sub Total</div>
                  <b className="b">$0</b>
                </div>
              </div>
              <div className="cart-footer">
                <div className="cell-footer">
                  <div className="total">Total</div>
                  <b className="b">$0</b>
                </div>
              </div>
              <form onSubmit={ProceedCheckout} method="POST">
                <button className="formLink1" type="submit">
                  <div className="proceed-to-checkout">Proceed to checkout</div>
                </button>
              </form>
            </div>
            <div className="formLink2" />
          </div>
        </div>
      </div>
      <Toaster />
    </section>
  );
};

export default StripeFree;
